const reviews = [
  {
    name: "夜风少年",
    role: "安卓玩家",
    avatar: "https://readdy.ai/api/search-image?query=simple%20flat%20vector%20avatar%20of%20a%20young%20male%20ninja%20with%20orange%20headband%2C%20warm%20orange%20background%2C%20minimal%20cartoon%20style&width=200&height=200&seq=avatar-1&orientation=squarish",
    text: "一直想玩汉化版的同人 RPG，之前找了半天都没找到合适的，在这里一次性就搞定，安装指引也很清楚，给力！",
  },
  {
    name: "晓の柚子",
    role: "电脑玩家",
    avatar: "https://readdy.ai/api/search-image?query=simple%20flat%20vector%20avatar%20of%20a%20young%20female%20ninja%20with%20long%20dark%20hair%2C%20warm%20amber%20background%2C%20minimal%20cartoon%20style&width=200&height=200&seq=avatar-2&orientation=squarish",
    text: "免安装版太方便了，解压就能玩，电脑配置不高也跑得很流畅。资源整理得井井有条，看得出很用心。",
  },
  {
    name: "卡卡西的写轮眼",
    role: "怀旧玩家",
    avatar: "https://readdy.ai/api/search-image?query=simple%20flat%20vector%20avatar%20of%20a%20boy%20ninja%20wearing%20mask%20and%20silver%20hair%2C%20warm%20orange%20background%2C%20minimal%20cartoon%20style&width=200&height=200&seq=avatar-3&orientation=squarish",
    text: "手机版和电脑版标注得很清楚，还有下载量的参考，省去了很多试错时间，玩到了好几款以前错过的作品。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
              About Us
            </p>
            <h2 className="font-heading mt-2 text-3xl font-bold text-foreground-950 md:text-4xl">
              关于火影同人游戏库
            </h2>
            <p className="mt-5 text-sm leading-8 text-foreground-600">
              火影同人游戏库是一个专注整理火影同人游戏下载资源的简体中文站点。我们深知喜欢火影的玩家们在寻找同人作品时，往往要耗费大量时间在论坛、社群之间来回翻找，还不一定能找到适配自己设备的版本。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-600">
              因此，我们把这些资源按手机版、电脑版、安卓、汉化版和免安装版等平台分门别类地整理在一起，并附上清晰的安装与启动指引，让每位玩家都能快速找到并进入属于自己的火影世界。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {[
                { icon: "ri-focus-3-line", label: "专注同人", desc: "只做同人作品整理" },
                { icon: "ri-map-pin-line", label: "按平台分类", desc: "找资源一目了然" },
                { icon: "ri-shield-check-line", label: "持续维护", desc: "资源实时更新" },
              ].map((item) => (
                <div key={item.label} className="rounded-lg bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-white">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <p className="mt-3 text-sm font-bold text-foreground-900">{item.label}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950">
              玩家口碑
            </h3>
            <div className="mt-6 space-y-5">
              {reviews.map((r) => (
                <blockquote
                  key={r.name}
                  className="rounded-lg bg-background-50 border border-background-200 p-5"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={r.avatar}
                      alt={`${r.name}的头像`}
                      className="h-11 w-11 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                      <p className="text-xs text-foreground-500">{r.role}</p>
                    </div>
                  </div>
                  <p className="mt-3 text-sm leading-7 text-foreground-600">“{r.text}”</p>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}